

const firstTruthy = (...readers) => readers.reduce((result, read) => result || read(), undefined);function normalizeSourceType(value) {
  const rawType = String(value || '').trim().toLowerCase();
  if (rawType.includes('web')) {
    return 'web';
  }
  if (rawType.includes('mcp')) {
    return 'mcp';
  }
  if (rawType.includes('instance_db') || rawType === 'instance' || rawType === 'database' || rawType === 'db') {
    return 'instance_db';
  }
  return 'local';
}

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function resolveNumber(value) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
}

function resolveSourceBreakdownFromRows(rows = []) {
  const sourceBreakdown = { instance_db: 0, local: 0, mcp: 0, web: 0 };
  rows.forEach((row) => {
    const sourceType = normalizeSourceType(row?.source_type || row?.source);
    sourceBreakdown[sourceType] += 1;
  });
  return sourceBreakdown;
}

function resolveLatestSourcingMeta(rows = []) {
  return [...rows].reverse().find((row) => {
    if (String(row?.evidence_kind || '').trim() !== 'sourcing') {
      return false;
    }
    const sourceMeta = resolveObject(row?.source_meta);
    return Object.keys(sourceMeta).length > 0;
  })?.source_meta || {};
}

function resolveLatestSourcingMetaFromTimeline(timelineItems = []) {
  return [...resolveArray(timelineItems)].reverse().find((item) => {
    if (String(item?.type || '').trim() !== 'sourcing_candidates') {
      return false;
    }
    const sourceMeta = resolveObject(item?.payload?.source_meta);
    return Object.keys(sourceMeta).length > 0;
  })?.payload?.source_meta || {};
}

function mergeSourceBreakdown(rowBreakdown = {}, metaBreakdown = {}) {
  const resolvedMeta = resolveObject(metaBreakdown);
  const hasMetaCounts = Object.values(resolvedMeta).some((value) => resolveNumber(value) > 0);
  const source = hasMetaCounts ? resolvedMeta : rowBreakdown;
  return {
    instance_db: resolveNumber(source.instance_db),
    local: resolveNumber(source.local),
    mcp: resolveNumber(source.mcp),
    web: resolveNumber(source.web),
  };
}

function resolveLatestMeta(rows = [], timelineItems = []) {
  const rowMeta = resolveLatestSourcingMeta(rows);
  if (Object.keys(rowMeta).length > 0) {
    return rowMeta;
  }
  return resolveLatestSourcingMetaFromTimeline(timelineItems);
}

export function selectCanvasEvidenceSummary(canvasEvidenceItems = [], timelineItems = []) {
  const evidenceRows = Array.isArray(canvasEvidenceItems) ? canvasEvidenceItems : [];
  const rowSourceBreakdown = resolveSourceBreakdownFromRows(evidenceRows);
  const sourcingMeta = resolveLatestMeta(evidenceRows, timelineItems);
  const observations = Array.isArray(Object(sourcingMeta).observations) ? sourcingMeta.observations : [];

  return {
    exploredCount: evidenceRows.length,
    hitCount: firstTruthy(() => (resolveNumber(Object(sourcingMeta).returned_count)), () => (evidenceRows.length)),
    sourceBreakdown: mergeSourceBreakdown(rowSourceBreakdown, Object(sourcingMeta).source_breakdown),
    sourcingObservations: observations,
    sourcingFinalStatus: String(firstTruthy(() => (Object(sourcingMeta).final_status), () => (''))).trim(),
    sourcingCurrentStage: String(firstTruthy(() => (Object(sourcingMeta).current_stage), () => (''))).trim(),
    sourcingCurrentStatus: String(firstTruthy(() => (Object(sourcingMeta).current_status), () => (''))).trim(),
    selectedSource: String(firstTruthy(() => (Object(sourcingMeta).selected_source), () => (''))).trim(),
    sourcePriority: resolveArray(Object(sourcingMeta).source_priority),
    fallbacks: resolveArray(Object(sourcingMeta).fallbacks),
    providerHealth: resolveArray(Object(sourcingMeta).provider_health),
    providerTrace: resolveArray(Object(sourcingMeta).provider_trace),
    routerReason: String(firstTruthy(() => (Object(sourcingMeta).router_reason), () => (''))).trim(),
  };
}

export default selectCanvasEvidenceSummary;
